import Box from '@mui/material/Box'

function ResourceListCell({
  children,
  width,
  minWidth,
  grow = false,
  shrink = true,
  center = false,
  stopPropagation = false,
}) {
  const sx = {
    overflow: 'hidden',
    minWidth: 0,
  }

  if (width !== undefined) {
    sx.width = width
  }

  if (minWidth !== undefined) {
    sx.minWidth = minWidth
  }

  if (grow) {
    sx.flexGrow = grow === true ? 1 : grow
  }

  if (!shrink) {
    sx.flexShrink = 0
  } else if (typeof shrink === 'number') {
    sx.flexShrink = shrink
  }

  if (center) {
    sx.display = 'flex'
    sx.justifyContent = 'center'
  }

  const eventHandlers = stopPropagation
    ? {
        onClick: (e) => { e.stopPropagation(); e.preventDefault() },
        onMouseDown: (e) => e.stopPropagation(),
      }
    : {}

  return (
    <Box sx={sx} {...eventHandlers}>
      {children}
    </Box>
  )
}

export default ResourceListCell
